import { Component } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { ZoneLine } from '../../_types/zone-line';
import { ZonesLinesService } from '../../_services/zones-lines.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { firstValueFrom } from 'rxjs';
import { LoginService } from 'src/app/modules/login/login.service';

@Component({
    selector: 'app-zones-line',
    templateUrl: './zones-line.component.html',
    styleUrls: ['./zones-line.component.scss'],
    standalone: false
})
export class ZonesLineComponent {
  public zoneLineFormGroup!: RxFormGroup;
  public zoneLine: ZoneLine = new ZoneLine();

  public allowWrite: boolean = false;
  public allowDelete: boolean = false;

  constructor(
    private zonesLinesService: ZonesLinesService,
    private config: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private loginService: LoginService
  ) {

    this.zoneLineFormGroup = this.formBuilder.formGroup<ZoneLine>(this.zoneLine) as RxFormGroup;
  }

  async ngOnInit() {
    let zoneLineId = this.config.data.zoneLineId;

    if (zoneLineId) {
      await this.loadZoneLine(zoneLineId);
    } else {
      this.zoneLine.zoneId = this.config.data.zoneId;
    }

    this.zoneLineFormGroup.patchValue(this.zoneLine);
    this.allowWrite = this.loginService.hasPermission("ZONES.WRITE");
    this.allowDelete = this.loginService.hasPermission("ZONES.DELETE");
  }

  async loadZoneLine(zoneLineId: string) {
    this.zoneLine = await firstValueFrom(this.zonesLinesService.get(zoneLineId));
  }

  async save() {
    let valid = this.formValidationService.validateForm(this.zoneLineFormGroup);
    if (valid) {
      this.zoneLine = Object.assign(this.zoneLine, this.zoneLineFormGroup.value);

      let zoneLine = await firstValueFrom(this.zonesLinesService.save(this.zoneLine));
      this.messageService.add({ closable: true, severity: 'success', summary: "Éxito", detail: "Línea guardada correctamente." });
      this.dynamicDialogRef.close(this.zoneLine.id ? null : zoneLine.id);

    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }

  async delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar la línea de zona?",
      header: "Eliminar línea",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.zonesLinesService.delete(this.zoneLine.id).subscribe({
          next: (data: any) => {
            this.messageService.add({ closable: true, severity: 'success', detail: "Línea eliminada correctamente." });
            this.cancel();
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }

  cancel() {
    this.dynamicDialogRef.close();
  }
}
